export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5051";

function getToken(kind = "customer") {
  return localStorage.getItem(kind === "admin" ? "adminToken" : "customerToken");
}

function parseResponseBody(contentType, text) {
  if (!contentType.includes("application/json")) return text;
  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
}

function requestError(data, status) {
  const validationMessage = data?.errors?.find((item) => item.msg)?.msg;
  const error = new Error(validationMessage || data?.message || `Request failed with status ${status}.`);
  error.status = status;
  error.details = data?.details;
  error.validationErrors = data?.errors || [];
  return error;
}

function uploadRequest(url, { method, body, headers, onUploadProgress }) {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open(method || "POST", url);
    Object.entries(headers).forEach(([key, value]) => request.setRequestHeader(key, value));

    request.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        onUploadProgress(Math.round((event.loaded / event.total) * 100));
      }
    });
    request.addEventListener("load", () => {
      const data = parseResponseBody(request.getResponseHeader("content-type") || "", request.responseText);
      if (request.status < 200 || request.status >= 300) {
        reject(requestError(data, request.status));
        return;
      }
      resolve(data);
    });
    request.addEventListener("error", () => reject(new Error("Network error. Check that the API server is running.")));
    request.addEventListener("abort", () => reject(new Error("Upload cancelled.")));
    request.send(body);
  });
}

export async function apiRequest(endpoint, options = {}) {
  const { tokenType, token: explicitToken, body, headers, onUploadProgress, ...rest } = options;
  const token = explicitToken || (tokenType ? getToken(tokenType) : null);
  const isForm = body instanceof FormData;
  const requestHeaders = {
    ...(isForm ? {} : { "Content-Type": "application/json" }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
  };

  if (isForm && onUploadProgress) {
    return uploadRequest(`${API_URL}${endpoint}`, {
      method: rest.method,
      body,
      headers: requestHeaders,
      onUploadProgress,
    });
  }

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...rest,
    headers: requestHeaders,
    body: isForm ? body : body ? JSON.stringify(body) : undefined,
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : await response.text();
  if (!response.ok) {
    throw requestError(data, response.status);
  }
  return data;
}

export function assetUrl(value, fallback) {
  if (!value) return fallback;
  if (value.startsWith("http")) return value;
  return `${API_URL}${value.startsWith("/") ? value : `/${value}`}`;
}

export function formatPrice(value) {
  return `${Number(value || 0).toLocaleString("en-EG")} EGP`;
}
